module.exports = __webpack_public_path__ + "img/part-1-2.7bcf7515.webp";